import React from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useToggle, useBoolean} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useUserResults} from './userResultsHelper';
import UserFilterPane from '../../Filters/UserFilterPane';
import {userPermissionsSelector} from '../../../store/selectors/user.selectors';
import UserWizard from '../../Wizards/UserWizard';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {UserFilterSchema} from '../../../api/DBSchema/User';
import SMCButton from '../../../components/Simple/SMCButton';
import ButtonsContainerStyles from "../../../pages/EditorPages/ButtonsContainerStyles";

function UserResults({
    userPermissions
}) {
    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);

    const {
        tableContent,
        isFetching,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        rowIdSelector,
        selectedObjects,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        reloadButtonOnClick,
        deleteButtonOnClick,
        toExcelAction
    } = useUserResults();

    const canDelete = userPermissions ? userPermissions.delete : false;
    const canCreate = userPermissions ? userPermissions.create : false;
    const buttonsClasses = ButtonsContainerStyles();

    const UserActionsMenu = ({ children }) => {
        return (
           <SMCButton 
                labelClassName={buttonsClasses.labelColor} 
                variant="ghost" 
                onClick={toExcelAction}>
                    To Excel
            </SMCButton>
        );
      };

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.showingUsers}>
            <div className="DrawResultsDiv">
            <SMCTableActions
                    openNewObjectWindow={openNewObjectWindow}
                    reloadButtonOnClick={reloadButtonOnClick}
                    deleteButtonOnClick={deleteButtonOnClick}
                    toggleFilterPane={toggleFilterPane}
                    canCreate={canCreate}
                    canDelete={canDelete}
                    isFetching={isFetching} 
                    actions={UserActionsMenu}
                    tableContent={tableContent}
                    isFilterPaneOpen={isFilterPaneOpen}
                    selectedObjects={selectedObjects}
                    initialSearch={filterObject}
                    onSearchChange={setFilterObject}
                    searchAttribute={UserFilterSchema.freeTextSearch}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <UserFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <UserWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    userPermissions: userPermissionsSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(UserResults);